import { BreadCrumb as BreadCrumbCP } from 'plataforma-fundacao-componentes';
import { useHistory } from 'react-router-dom';

export interface IBreadCrumbItem {
  nome: string;
  url?: string;
}
export interface IBreadCrumb {
  itens: IBreadCrumbItem[];
}

export default function BreadCrumb({ itens }: IBreadCrumb) {
  const history = useHistory();

  return (
    <BreadCrumbCP
      path={itens.map((item: IBreadCrumbItem) => {
        if (item.url) {
          return {
            label: item.nome,
            onClick: () => history.push(item?.url!),
          };
        } else {
          return {
            label: item.nome,
          };
        }
      })}
    />
  );
}
